import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('DailyBonusPanel').create(({ theme }) => ({
  root: {
    width: '90%',
    minHeight: '98px',
    display: 'flex',
    flexDirection: 'column',
    padding: '16px',
    background: 'linear-gradient(180deg, #243553 0%, #19212F 100%)',
    borderRadius: '8px',
    justifyContent: 'space-between',
  },

  dailyRewardsText: {
    display: 'block',
    lineHeight: '17px',
    textAlign: 'left',
    width: '50%',
    fontWeight: 450,
    fontSize: theme.sizes.texts.fontSize.m,
    color: theme.colors.text.primary,
  },

  topContainer: {
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'space-between',
  },

  receiveWrapper: {
    display: 'flex',
    padding: '8px 16px',
    alignItems: 'center',
    background: theme.colors.text.primary,
    borderRadius: '8px',
    gap: '4px',
    span: {
      fontWeight: 560,
      fontSize: theme.sizes.texts.fontSize.m,
      lineHeight: theme.sizes.texts.lineHeight.xl,
      color: 'rgba(29, 30, 34, 1)',
    },
  },

  progressWrapper: {
    display: 'flex',
    width: '100%',
    gap: '8px',
  },

  dailyBonusProgressBlock: {
    width: '12.5%',
    height: '8px',
    background: theme.colors.button.primary.background,
    borderRadius: '8px',

    '&[data-phase="currentDay"]': {
      background: theme.colors.text.primary,
      boxShadow: '0px 0px 10px 3px rgba(41, 144, 255, 1)',
    },

    '&[data-phase="nextDay"]': {
      background: 'rgba(255, 255, 255, 0.16)',
    },
  },
}))
